import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin.component';
import { AuthGuard } from '../../shared/auth/auth.guard';
const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'user-management',
        loadChildren: () =>
          import('./user-management/user-management.module').then(
            (m) => m.UserManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'project-management',
        loadChildren: () =>
          import('./project-management/project-management.module').then(
            (m) => m.ProjectManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'project-user-management',
        loadChildren: () =>
          import('./project-user-management/project-user-management.module').then(
            (m) => m.ProjectUserManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'ats-system-settings',
        loadChildren: () =>
          import('./ats-system-settings/ats-system-settings.module').then(
            (m) => m.AtsSystemSettigsModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'team-management',
        loadChildren: () =>
          import('./team-management/team-management.module').then(
            (m) => m.TeamManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'support-management',
        loadChildren: () =>
          import('./support-management/support-management.module').then(
            (m) => m.SupportManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'company-management',
        loadChildren: () =>
          import('./company-management/company-management.module').then(
            (m) => m.CompanyManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'business-rules',
        loadChildren: () =>
          import('./business-rules/business-rules.module').then(
            (m) => m.BusinesManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'content-management',
        loadChildren: () =>
          import('./content-management/content-management.module').then(
            (m) => m.ContentManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'general-setting',
        loadChildren: () =>
          import('./general-setting-management/general-setting-management.module').then(
            (m) => m.GenarelSettingManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'dynamic-form-management',
        loadChildren: () =>
          import('./dynamic-form-management/dynamic-form-management.module').then(
            (m) => m.DynamicFormManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'metabase-management',
        loadChildren: () =>
          import('./metabase-management/metabase-management-routing.module').then(
            (m) => m.MetabaseManagementRoutingModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'log-management',
        loadChildren: () =>
          import('./log-management/log-management.module').then(
            (m) => m.LogManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'integration-management',
        loadChildren: () =>
          import('./integration-management/integration-management.module').then(
            (m) => m.IntegrationManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'app-version-management',
        loadChildren: () =>
          import('./app-version-management/app-version-management-routing.module').then(
            (m) => m.AppVersionManagementRoutingModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'action-logs',
        loadChildren: () =>
          import('./action-logs/action-logs-routing.module').then(
            (m) => m.ActionLogsRoutingModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'poi-category-region-management',
        loadChildren: () =>
          import('./poi-category-region-management/poi-category-region-management.module').then(
            (m) => m.PoiCategoryRegionManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      },
      {
        path: 'remaining-rights-management',
        loadChildren: () =>
          import('./remaining-rights-management/remaining-rights-management.module').then(
            (m) => m.RemainingRightsManagementModule
          ),
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
